import { TableCell, TableHead, TableRow } from "@mui/material"
import { useTranslation } from "react-i18next"

export const ValidationRuleTableTitle = () => {

    const { t } = useTranslation();

    return (
        <TableHead>
            <TableRow>
                <TableCell width={50}></TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#666', borderBottom: '1px solid #e0e0e0' }}>
                    {t("ValidationRule.ActivityName")}
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#666', borderBottom: '1px solid #e0e0e0' }}>
                    {t("ValidationRule.ActivityResponsable")}
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#666', borderBottom: '1px solid #e0e0e0' }}>
                    {t("ValidationRule.ActivityTermT")}
                </TableCell>
            </TableRow>
        </TableHead>
    )
}